module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-1-23aaf7c40176d0ca7333157d5888b89f.jpg";